// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"32808b300af21553","5285":"0acde2e17ee2a709"}[chunkId] + ".css";
};